module.exports = __webpack_public_path__ + "media/images/profile-photo-35451b206d4d82a66beeed77e2f52e97.png";